import {
  NgbAlertModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { GuideFiveComponent } from './components/guides/guide-five/guide-five.component';
import { GuideFourComponent } from './components/guides/guide-four/guide-four.component';
import { GuideOneComponent } from './components/guides/guide-one/guide-one.component';
import { GuideSevenComponent } from './components/guides/guide-seven/guide-seven.component';
import { GuideSixComponent } from './components/guides/guide-six/guide-six.component';
import { GuideThreeComponent } from './components/guides/guide-three/guide-three.component';
import { GuideTwoComponent } from './components/guides/guide-two/guide-two.component';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ResourceFiveComponent } from './components/resources/resource-five/resource-five.component';
import { ResourceFourComponent } from './components/resources/resource-four/resource-four.component';
import { ResourceOneComponent } from './components/resources/resource-one/resource-one.component';
import { ResourceSevenComponent } from './components/resources/resource-seven/resource-seven.component';
import { ResourceSixComponent } from './components/resources/resource-six/resource-six.component';
import { ResourceThreeComponent } from './components/resources/resource-three/resource-three.component';
import { ResourceTwoComponent } from './components/resources/resource-two/resource-two.component';
import { StepFiveComponent } from './components/stepper/step-five/step-five.component';
import { StepFourComponent } from './components/stepper/step-four/step-four.component';
import { StepOneComponent } from './components/stepper/step-one/step-one.component';
import { StepSevenComponent } from './components/stepper/step-seven/step-seven.component';
import { StepSixComponent } from './components/stepper/step-six/step-six.component';
import { StepThreeComponent } from './components/stepper/step-three/step-three.component';
import { StepTwoComponent } from './components/stepper/step-two/step-two.component';
import { UponRegistrationRoutingModule } from './upon-registration-routing.module';
import { WizardComponent } from './pages/wizard.component';

@NgModule({
  declarations: [
    GuideOneComponent,
    GuideTwoComponent,
    GuideThreeComponent,
    GuideFourComponent,
    GuideFiveComponent,
    GuideSixComponent,
    GuideSevenComponent,
    ResourceOneComponent,
    ResourceTwoComponent,
    ResourceThreeComponent,
    ResourceFourComponent,
    ResourceFiveComponent,
    ResourceSixComponent,
    ResourceSevenComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    StepFourComponent,
    StepFiveComponent,
    StepSixComponent,
    StepSevenComponent,
    WizardComponent,
  ],
  imports: [
    CommonModule,
    UponRegistrationRoutingModule,
    NgbNavModule,
    NgbAlertModule,
    NgbNavModule,
    NgbTooltipModule,
    ReactiveFormsModule,
  ],
  exports: [WizardComponent],
})
export class UponRegistrationModule {}
